export const salesPurchasesTranslations: Record<string, string> = {
  // Shared sales, purchases, document, and workflow labels.
  'Sales': 'المبيعات',
  'Purchases': 'المشتريات',
  'Invoices': 'فواتير المبيعات',
  'Invoice': 'فاتورة مبيعات',
  'Sales Invoices': 'فواتير المبيعات',
  'Quotes': 'عروض الأسعار',
  'Quote': 'عرض سعر',
  'Quotations': 'عروض الأسعار',
  'Purchase Orders': 'أوامر الشراء',
  'Purchase Order': 'أمر شراء',
  'Bills': 'فواتير المشتريات',
  'Bill': 'فاتورة مشتريات',
  'Deliveries': 'التسليمات',
  'Delivery': 'تسليم',
  'Delivery Notes': 'إشعارات التسليم',
  'Delivery Note': 'إشعار تسليم',
  'Goods Receipt': 'إشعار استلام بضاعة',
  'Expense Submissions': 'طلبات المصروفات',
  'Expense Submission Details': 'تفاصيل طلب المصروف',
  'Landed Costs': 'التكاليف الإضافية للمخزون',
  'Contacts': 'جهات الاتصال',
  'Customer': 'العميل',
  'Customers': 'العملاء',
  'customer': 'عميل',
  'Supplier': 'المورد',
  'Suppliers': 'الموردون',
  'supplier': 'مورد',
  'Vendor': 'المورد',
  'Both': 'كلاهما',
  'All': 'الكل',
  'New': 'جديد',
  'Add': 'إضافة',
  'Edit': 'تعديل',
  'Update': 'تحديث',
  'Delete': 'حذف',
  'Archive': 'أرشفة',
  'Restore': 'استعادة',
  'Remove': 'إزالة',
  'Save': 'حفظ',
  'Save Changes': 'حفظ التغييرات',
  'Saving...': 'جاري الحفظ...',
  'Cancel': 'إلغاء',
  'Close': 'إغلاق',
  'Clear': 'مسح',
  'Reset': 'إعادة ضبط',
  'Back': 'رجوع',
  'Next': 'التالي',
  'Continue': 'متابعة',
  'Done': 'تم',
  'View': 'عرض',
  'Download': 'تنزيل',
  'Upload': 'رفع',
  'Import': 'استيراد',
  'Export': 'تصدير',
  'Print': 'طباعة',
  'Email': 'البريد الإلكتروني',
  'Copy': 'نسخ',
  'Search': 'بحث',
  'Filter': 'تصفية',
  'Filters': 'عوامل التصفية',
  'Advanced Filters': 'عوامل تصفية متقدمة',
  'More filters': 'مزيد من عوامل التصفية',
  'Less filters': 'عوامل تصفية أقل',
  'Apply Filters': 'تطبيق عوامل التصفية',
  'Reset Filters': 'إعادة ضبط عوامل التصفية',
  'Clear filters': 'مسح عوامل التصفية',
  'Table Settings': 'إعدادات الجدول',
  'Column selection': 'اختيار الأعمدة',
  'Visible & Order': 'الظهور والترتيب',
  'Drag to reorder columns': 'اسحب لإعادة ترتيب الأعمدة',
  'Actions': 'الإجراءات',
  'Action Log': 'سجل الإجراءات',
  'Action By': 'منفذ الإجراء',
  'Action Type': 'نوع الإجراء',
  'Event': 'الحدث',
  'Changes': 'التغييرات',
  'History': 'السجل',
  'History & Notes': 'السجل والملاحظات',
  'History and notes': 'السجل والملاحظات',
  'Discussion': 'المناقشة',
  'Discussion Threads': 'سلاسل المناقشة',
  'Open Thread': 'فتح سلسلة المناقشة',
  'Internal thread for quote': 'سلسلة مناقشة داخلية لعرض السعر',
  'Add note': 'إضافة ملاحظة',
  'Reply posted': 'تم نشر الرد',
  'Thread started': 'تم بدء سلسلة المناقشة',
  'Failed to post reply': 'تعذر نشر الرد',
  'Failed to start thread': 'تعذر بدء سلسلة المناقشة',

  // Common fields, table headings, choices, and statuses.
  'Name': 'الاسم',
  'Name *': 'الاسم *',
  'Description': 'الوصف',
  'Description *': 'الوصف *',
  'Description...': 'الوصف...',
  'Reference': 'المرجع',
  'Reference/Name *': 'المرجع/الاسم *',
  'Ref': 'المرجع',
  'Ref / Number': 'المرجع / الرقم',
  'Number': 'الرقم',
  'Date': 'التاريخ',
  'Date *': 'التاريخ *',
  'Due Date': 'تاريخ الاستحقاق',
  'Expiry Date': 'تاريخ الانتهاء',
  'Delivery Date': 'تاريخ التسليم',
  'Created At': 'تاريخ الإنشاء',
  'From Date': 'من تاريخ',
  'To Date': 'إلى تاريخ',
  'Start Date': 'تاريخ البدء',
  'End Date': 'تاريخ الانتهاء',
  'End Date (Optional)': 'تاريخ الانتهاء (اختياري)',
  'As At Date': 'كما في تاريخ',
  'Date Range': 'نطاق التاريخ',
  'Date From': 'التاريخ من',
  'Date To': 'التاريخ إلى',
  'Status': 'الحالة',
  'Status:': 'الحالة:',
  'All Statuses': 'جميع الحالات',
  'All Payment Status': 'جميع حالات الدفع',
  'All Delivery Status': 'جميع حالات التسليم',
  'Payment Status': 'حالة الدفع',
  'Delivery Status': 'حالة التسليم',
  'Shipment Status': 'حالة الشحنة',
  'Invoice Status': 'حالة الفاتورة',
  'Draft': 'مسودة',
  'Sent': 'مرسل',
  'Accepted': 'مقبول',
  'Declined': 'مرفوض من العميل',
  'Rejected': 'مرفوض',
  'Awaiting Approval': 'بانتظار الاعتماد',
  'awaiting approval': 'بانتظار الاعتماد',
  'Awaiting Payment': 'بانتظار السداد',
  'awaiting payment': 'بانتظار السداد',
  'Approved': 'معتمد',
  'Approved for Sending': 'معتمد للإرسال',
  'Billed': 'تمت فوترته',
  'Invoiced': 'تمت فوترته',
  'Converted': 'تم التحويل',
  'Received': 'مستلم',
  'Assigned': 'مُسند',
  'Shipped': 'تم الشحن',
  'Delivered': 'تم التسليم',
  'Returned': 'مرتجع',
  'CheckingOut': 'قيد إخراج المخزون',
  'Paid': 'مدفوع',
  'Unpaid': 'غير مدفوع',
  'Partially Paid': 'مدفوع جزئيًا',
  'Pending': 'قيد الانتظار',
  'Void': 'ملغاة',
  'Deleted': 'محذوفة',
  'Active': 'نشط',
  'Inactive': 'غير نشط',
  'Archived': 'مؤرشف',
  'Available': 'متاح',
  'Allocated': 'موزع',
  'Posted': 'مُرحّل',
  'Ready': 'جاهز',
  'Enabled': 'مفعّل',
  'Disabled': 'معطّل',
  'None': 'لا شيء',
  'No': 'لا',
  'Yes': 'نعم',
  'Other': 'أخرى',
  'Unknown': 'غير معروف',
  'Unassigned': 'غير مُسند',
  'N/A': 'غير متاح',
  'Not provided': 'غير متوفر',
  'Not Processed': 'لم تتم المعالجة',
  'Amount': 'المبلغ',
  'Amount *': 'المبلغ *',
  'Amounts': 'المبالغ',
  'Amounts are': 'المبالغ',
  'Amount Paid': 'المبلغ المدفوع',
  'Amount Due': 'المبلغ المستحق',
  'Amount Range': 'نطاق المبلغ',
  'Total': 'الإجمالي',
  'TOTAL': 'الإجمالي',
  'Subtotal': 'الإجمالي الفرعي',
  'Gross Total': 'الإجمالي قبل الخصم',
  'Total Amount': 'إجمالي المبلغ',
  'Total Amount *': 'إجمالي المبلغ *',
  'Total Amount:': 'إجمالي المبلغ:',
  'Total Due': 'إجمالي المستحق',
  'Total Paid': 'إجمالي المدفوع',
  'Total Paid:': 'إجمالي المدفوع:',
  'Total Value': 'إجمالي القيمة',
  'Total Tax': 'إجمالي الضريبة',
  'Tax Total': 'إجمالي الضريبة',
  'Total Credit': 'إجمالي الرصيد الدائن',
  'Less: Discount': 'يُخصم: الخصم',
  'Less:': 'يُخصم:',
  'Discount': 'الخصم',
  'Discount (%)': 'الخصم (٪)',
  'Disc': 'خصم',
  'Disc %': 'نسبة الخصم',
  'Amt': 'المبلغ',
  'Tax': 'الضريبة',
  'Tax Rate': 'معدل الضريبة',
  'Tax rate': 'معدل الضريبة',
  'Tax Exempt (0%)': 'معفى من الضريبة (0٪)',
  'Tax Inclusive': 'شامل الضريبة',
  'Tax Exclusive': 'غير شامل الضريبة',
  'No Tax': 'بدون ضريبة',
  'Amounts are tax exclusive': 'المبالغ غير شاملة للضريبة',
  'Currency': 'العملة',
  'Currency Code': 'رمز العملة',
  'Default Currency': 'العملة الافتراضية',
  'Account': 'الحساب',
  'Account*': 'الحساب *',
  'Account Number': 'رقم الحساب',
  'Default Account': 'الحساب الافتراضي',
  'Select Account': 'اختر حسابًا',
  'Select account': 'اختر حسابًا',
  'Select account...': 'اختر حسابًا...',
  'Select Currency': 'اختر العملة',
  'Select Tax': 'اختر الضريبة',
  'Select Theme': 'اختر القالب',
  'Select': 'اختر',
  'Min': 'الحد الأدنى',
  'Max': 'الحد الأقصى',
  'Qty': 'الكمية',
  'QTY *': 'الكمية *',
  'Quantity': 'الكمية',
  'Ordered': 'المطلوب',
  'Ordered Qty': 'الكمية المطلوبة',
  'Original Qty': 'الكمية الأصلية',
  'Unit Price': 'سعر الوحدة',
  'Unit Amount': 'مبلغ الوحدة',
  'Price': 'السعر',
  'Price *': 'السعر *',
  'Item': 'الصنف',
  'Items': 'الأصناف',
  'Line Items': 'بنود المستند',
  'Add New Line': 'إضافة بند جديد',
  'Add another line': 'إضافة بند آخر',
  'Remove item': 'إزالة الصنف',
  'SKU / Item': 'رمز الصنف / الصنف',
  'SKU / Item (optional)': 'رمز الصنف / الصنف (اختياري)',
  'Item (Code - Name)': 'الصنف (الرمز - الاسم)',
  'Code': 'الرمز',
  'Code *': 'الرمز *',
  'Product Name': 'اسم المنتج',
  'Tags': 'الوسوم',
  'Tag': 'وسم',
  'All Tags': 'جميع الوسوم',
  'Select a tag...': 'اختر وسمًا...',
  'Select a tag to add...': 'اختر وسمًا لإضافته...',
  'Enter a tag...': 'أدخل وسمًا...',
  'Search for a tag...': 'ابحث عن وسم...',
  'No tags set up yet.': 'لم يتم إعداد وسوم بعد.',
  'No tags set up yet. Go to Accounting': 'لم يتم إعداد وسوم بعد. انتقل إلى المحاسبة',
  'Tags to create some.': 'والوسوم لإنشاء بعضها.',
  'Professional': 'احترافي',
  'Minimal': 'بسيط',
  'Modern': 'عصري',
  'Standard': 'قياسي',
  'Theme': 'القالب',
  'Branding Theme': 'قالب العلامة التجارية',
  'Branding theme': 'قالب العلامة التجارية',
  'Standard Odoo-Matching Print Layout': 'تخطيط طباعة قياسي متوافق مع Odoo',

  // Invoice and credit-note UI.
  'New Invoice': 'فاتورة مبيعات جديدة',
  'New Sales Invoice': 'فاتورة مبيعات جديدة',
  'New Repeating Invoice': 'فاتورة دورية جديدة',
  'New Credit Note': 'إشعار دائن جديد',
  'New Refund': 'رد مبلغ جديد',
  'Edit Invoice': 'تعديل فاتورة المبيعات',
  'Update Invoice': 'تحديث فاتورة المبيعات',
  'Create Invoice': 'إنشاء فاتورة مبيعات',
  'Create Delivery Note': 'إنشاء إشعار تسليم',
  'Invoice number': 'رقم الفاتورة',
  'Invoice Number': 'رقم الفاتورة',
  'Credit Note #': 'رقم الإشعار الدائن',
  'Credit Note Number': 'رقم الإشعار الدائن',
  'Credit Notes': 'الإشعارات الدائنة',
  'Credit Applied': 'تم تطبيق الرصيد الدائن',
  'Apply Credit': 'تطبيق الرصيد الدائن',
  'Refund': 'رد مبلغ',
  'Manage and track your customer invoices': 'إدارة فواتير العملاء ومتابعتها',
  'View, edit and manage your sales all in one place.': 'اعرض مبيعاتك وعدّلها وأدرها من مكان واحد.',
  'Search invoices...': 'ابحث في الفواتير...',
  'Search invoice number or customer...': 'ابحث برقم الفاتورة أو العميل...',
  'No invoices found': 'لم يتم العثور على فواتير',
  'No invoices found matching your criteria.': 'لا توجد فواتير مطابقة لمعايير البحث.',
  'No Invoices Selected': 'لم يتم تحديد فواتير',
  'Add your first invoice to start tracking receivables': 'أضف أول فاتورة لبدء متابعة الذمم المدينة',
  'Invoice approved': 'تم اعتماد الفاتورة',
  'Invoice deleted successfully': 'تم حذف الفاتورة بنجاح',
  'Invoice reminders updated successfully': 'تم تحديث تذكيرات الفاتورة بنجاح',
  'Invoice saved. Journal posting will be handled server-side separately.': 'تم حفظ الفاتورة. ستتم معالجة ترحيل القيد محاسبيًا على الخادم بصورة مستقلة.',
  'Journal posting will be handled server-side separately.': 'ستتم معالجة ترحيل القيد محاسبيًا على الخادم بصورة مستقلة.',
  'Excel file exported successfully': 'تم تصدير ملف Excel بنجاح',
  'PDF downloaded successfully': 'تم تنزيل ملف PDF بنجاح',
  'File attached successfully': 'تم إرفاق الملف بنجاح',
  'Attachment removed': 'تمت إزالة المرفق',
  'Link copied to clipboard': 'تم نسخ الرابط إلى الحافظة',
  'Contact added successfully': 'تمت إضافة جهة الاتصال بنجاح',
  'Delivery note created successfully': 'تم إنشاء إشعار التسليم بنجاح',
  'Delivery note updated': 'تم تحديث إشعار التسليم',
  'Delivery notes created from Invoice': 'إشعارات التسليم المنشأة من الفاتورة',
  'Delivery confirmed and inventory updated': 'تم تأكيد التسليم وتحديث المخزون',
  'Could not apply credit note': 'تعذر تطبيق الإشعار الدائن',
  'Credit note not found': 'لم يتم العثور على الإشعار الدائن',
  'Could not attach file to invoice': 'تعذر إرفاق الملف بالفاتورة',
  'Could not generate recurring invoice': 'تعذر إنشاء الفاتورة الدورية',
  'Could not load local invoice data': 'تعذر تحميل بيانات الفواتير المحلية',
  'Could not load payment history': 'تعذر تحميل سجل المدفوعات',
  'Could not record payment': 'تعذر تسجيل الدفعة',
  'Could not remove attachment': 'تعذر إزالة المرفق',
  'Could not remove payment': 'تعذر إزالة الدفعة',
  'Could not upload file': 'تعذر رفع الملف',
  'Failed to add contact': 'تعذرت إضافة جهة الاتصال',
  'Failed to confirm delivery': 'تعذر تأكيد التسليم',
  'Failed to generate PDF': 'تعذر إنشاء ملف PDF',
  'Failed to import invoices': 'تعذر استيراد الفواتير',
  'Failed to load invoices': 'تعذر تحميل الفواتير',
  'Failed to load payment history': 'تعذر تحميل سجل المدفوعات',
  'Failed to perform bulk action': 'تعذر تنفيذ الإجراء الجماعي',
  'Failed to record payment': 'تعذر تسجيل الدفعة',
  'Failed to remove attachment': 'تعذر إزالة المرفق',
  'Failed to remove payment': 'تعذر إزالة الدفعة',
  'Failed to save invoice': 'تعذر حفظ الفاتورة',
  'Failed to save reminder settings': 'تعذر حفظ إعدادات التذكير',
  'File size must be less than 5MB': 'يجب أن يقل حجم الملف عن 5 ميجابايت',
  'Upload did not return a file URL': 'لم تُرجع عملية الرفع رابطًا للملف',
  'Please add at least one item with a description.': 'يرجى إضافة صنف واحد على الأقل مع وصفه.',
  'Please enter a positive payment amount': 'يرجى إدخال مبلغ دفعة موجب',
  'Please enter an email address': 'يرجى إدخال عنوان بريد إلكتروني',
  'Please select a contact before saving.': 'يرجى اختيار جهة اتصال قبل الحفظ.',
  'Please select a deposit account and at least one invoice': 'يرجى اختيار حساب الإيداع وفاتورة واحدة على الأقل',
  'Please select a payment account': 'يرجى اختيار حساب الدفع',
  'Please select an invoice': 'يرجى اختيار فاتورة',
  'Please specify at least one quantity to ship.': 'يرجى تحديد كمية واحدة على الأقل للشحن.',
  'Receiver name is mandatory': 'اسم المستلم إلزامي',
  'Signature is mandatory': 'التوقيع إلزامي',
  'To void this invoice, you must remove the payments first.': 'لإلغاء هذه الفاتورة، يجب إزالة المدفوعات أولًا.',
  'Cannot Void (Payments Exist)': 'لا يمكن الإلغاء (توجد مدفوعات)',
  'The amount due on this invoice will increase.': 'سيزداد المبلغ المستحق على هذه الفاتورة.',
  'This action will mark the invoice as deleted.': 'سيؤدي هذا الإجراء إلى تعليم الفاتورة كمحذوفة.',
  'Are you sure you want to delete invoice': 'هل أنت متأكد من حذف الفاتورة',
  'Delete Invoice': 'حذف الفاتورة',
  'Delete Invoice?': 'حذف الفاتورة؟',
  'Approve': 'اعتماد',
  'Approve for Sending': 'اعتماد للإرسال',
  'Ask for Approval': 'طلب الاعتماد',
  'Submit for Approval': 'إرسال للاعتماد',
  'Save as Draft': 'حفظ كمسودة',
  'Send Invoice': 'إرسال الفاتورة',
  'Get Link': 'الحصول على الرابط',
  'Share Link': 'مشاركة الرابط',
  'Copy share link': 'نسخ رابط المشاركة',
  'Copy this invoice': 'نسخ هذه الفاتورة',
  'Scan QR code': 'مسح رمز QR',
  'Scan with Mobile': 'المسح باستخدام الهاتف',
  'Invoice Link': 'رابط الفاتورة',
  'Anyone with this link can view the invoice online.': 'يمكن لأي شخص لديه هذا الرابط عرض الفاتورة عبر الإنترنت.',
  'Scan this QR code with any mobile device to view this invoice live in the portal.': 'امسح رمز QR هذا بأي جهاز محمول لعرض الفاتورة مباشرة في البوابة.',
  'Linked Delivery Notes': 'إشعارات التسليم المرتبطة',
  'View Linked Delivery Note': 'عرض إشعار التسليم المرتبط',
  'Shipments & Delivery Notes': 'الشحنات وإشعارات التسليم',
  'Create Shipment': 'إنشاء شحنة',
  'Items to Ship': 'الأصناف المطلوب شحنها',
  'To Ship': 'للشحن',
  'Confirm Delivery (POD)': 'تأكيد التسليم (إثبات التسليم)',
  'Print Delivery Note': 'طباعة إشعار التسليم',
  'Receipt or note': 'إيصال أو ملاحظة',
  'Search receipt or note': 'ابحث عن إيصال أو ملاحظة',
  'Batch reference...': 'مرجع الدفعة...',
  'New Batch Payment': 'دفعة مجمعة جديدة',
  'Select invoices from the left to record a batch deposit': 'اختر الفواتير من اليمين لتسجيل إيداع مجمع',
  'DEPOSIT ACCOUNT': 'حساب الإيداع',
  'TOTAL PAYMENT': 'إجمالي الدفعة',
  'Payment Allocation': 'توزيع الدفعة',
  'Make Payment': 'إجراء دفعة',
  'Add Payment': 'إضافة دفعة',
  'Payment removed successfully': 'تمت إزالة الدفعة بنجاح',
  'Remove Payment?': 'إزالة الدفعة؟',
  'Remove and Redo': 'إزالة وإعادة التسجيل',
  'Printing functionality for multiple invoices is being prepared.': 'يجري إعداد طباعة عدة فواتير.',
  'Email functionality for multiple invoices is being prepared.': 'يجري إعداد إرسال عدة فواتير بالبريد الإلكتروني.',

  // Quote UI and reminder content.
  'New Quote': 'عرض سعر جديد',
  'New Quotation': 'عرض سعر جديد',
  'Create New Quote': 'إنشاء عرض سعر جديد',
  'Edit Quote': 'تعديل عرض السعر',
  'Save Quote': 'حفظ عرض السعر',
  'Quote number': 'رقم عرض السعر',
  'Quote Number': 'رقم عرض السعر',
  'Manage and track your customer quotations': 'إدارة عروض أسعار العملاء ومتابعتها',
  'Search quotes...': 'ابحث في عروض الأسعار...',
  'No quotes found matching your criteria.': 'لا توجد عروض أسعار مطابقة لمعايير البحث.',
  'Send Quote': 'إرسال عرض السعر',
  'Send Quote via Gmail': 'إرسال عرض السعر عبر Gmail',
  'Accept': 'قبول',
  'Decline': 'رفض',
  'Decline Quote': 'رفض عرض السعر',
  'Confirm Decline': 'تأكيد الرفض',
  'Reason for declining *': 'سبب الرفض *',
  'Tell us why this quote is being declined...': 'أدخل سبب رفض عرض السعر...',
  'Quote converted to invoice successfully': 'تم تحويل عرض السعر إلى فاتورة بنجاح',
  'Quote deleted successfully': 'تم حذف عرض السعر بنجاح',
  'Quote restored to Draft successfully': 'تمت استعادة عرض السعر إلى حالة مسودة بنجاح',
  'Quote updated successfully': 'تم تحديث عرض السعر بنجاح',
  'Reminder settings saved successfully': 'تم حفظ إعدادات التذكير بنجاح',
  'CSV template downloaded successfully': 'تم تنزيل قالب CSV بنجاح',
  'Attachments are unavailable in local mode.': 'المرفقات غير متاحة في الوضع المحلي.',
  'Bulk quote updates are unavailable in local mode.': 'التحديث الجماعي لعروض الأسعار غير متاح في الوضع المحلي.',
  'Quote imports are unavailable in local mode.': 'استيراد عروض الأسعار غير متاح في الوضع المحلي.',
  'File is too large. Max size is 30MB': 'الملف كبير جدًا. الحد الأقصى 30 ميجابايت',
  'Contact email missing': 'البريد الإلكتروني لجهة الاتصال غير متوفر',
  'Failed to add account': 'تعذرت إضافة الحساب',
  'Failed to convert quote to invoice': 'تعذر تحويل عرض السعر إلى فاتورة',
  'Failed to create partial invoice': 'تعذر إنشاء فاتورة جزئية',
  'Failed to delete quote': 'تعذر حذف عرض السعر',
  'Failed to import quotes': 'تعذر استيراد عروض الأسعار',
  'Failed to load quotes': 'تعذر تحميل عروض الأسعار',
  'Failed to restore quote': 'تعذرت استعادة عرض السعر',
  'Failed to save quote': 'تعذر حفظ عرض السعر',
  'Failed to update quote status': 'تعذر تحديث حالة عرض السعر',
  'Failed to update status': 'تعذر تحديث الحالة',
  'At least one item is required': 'يلزم إضافة صنف واحد على الأقل',
  'Please ensure both Date and Expiry Date are filled.': 'يرجى إدخال التاريخ وتاريخ الانتهاء.',
  'Please fill in all required fields': 'يرجى استكمال جميع الحقول المطلوبة',
  'Please specify at least one item quantity to invoice.': 'يرجى تحديد كمية صنف واحدة على الأقل لفوترتها.',
  'You must be signed in to copy a quote': 'يجب تسجيل الدخول لنسخ عرض السعر',
  'The copied document was not returned': 'لم تتم إعادة المستند المنسوخ',
  'Create Partial Invoice': 'إنشاء فاتورة جزئية',
  'Full Invoice': 'فاتورة كاملة',
  'Partial Invoice': 'فاتورة جزئية',
  'Invoice Remaining (': 'فوتر المتبقي (',
  'Qty to Invoice Now': 'الكمية المراد فوترتها الآن',
  'Previously Invoiced': 'تمت فوترته سابقًا',
  'To Invoice': 'المتبقي للفوترة',
  'Amount to Invoice': 'المبلغ المتبقي للفوترة',
  'Invoiced Amount': 'المبلغ المفوتر',
  'Fully Invoiced': 'مفوتر بالكامل',
  'fully invoiced': 'مفوتر بالكامل',
  'Partially Invoiced': 'مفوتر جزئيًا',
  'partially invoiced': 'مفوتر جزئيًا',
  'Not Invoiced': 'غير مفوتر',
  'not invoiced': 'غير مفوتر',
  'Invoices created from Quote': 'الفواتير المنشأة من عرض السعر',
  'Linked Invoices': 'الفواتير المرتبطة',
  'View Linked Invoice': 'عرض الفاتورة المرتبطة',
  'Close linked invoices': 'إغلاق الفواتير المرتبطة',
  'Information about (partial) invoicing': 'معلومات عن الفوترة الكاملة أو الجزئية',
  'Note: Invoiced items will appear as a new Draft Invoice.': 'ملاحظة: ستظهر الأصناف المفوترة في فاتورة جديدة بحالة مسودة.',
  'Automated Quote Reminders': 'تذكيرات عروض الأسعار الآلية',
  'Automatically notify customers via email based on quote expiry': 'إشعار العملاء تلقائيًا بالبريد الإلكتروني وفق تاريخ انتهاء عرض السعر',
  'Enable Automated Reminder System': 'تفعيل نظام التذكير الآلي',
  'Enable the system above to configure automated customer touchpoints and templates.': 'فعّل النظام أعلاه لإعداد نقاط التواصل الآلية مع العملاء والقوالب.',
  'Reminder system is currently dormant': 'نظام التذكير غير مفعّل حاليًا',
  '7 Days Before Expiry': 'قبل الانتهاء بسبعة أيام',
  'On Expiry Date': 'في تاريخ الانتهاء',
  '7 Days After Expiry': 'بعد الانتهاء بسبعة أيام',
  '14 Days After Expiry': 'بعد الانتهاء بأربعة عشر يومًا',
  'Email Message Content': 'محتوى رسالة البريد الإلكتروني',
  'Personalization Placeholders': 'عناصر التخصيص النائبة',
  'These tags will be replaced automatically when the reminder is generated.': 'سيتم استبدال هذه العناصر تلقائيًا عند إنشاء التذكير.',

  'Save Activation Settings': 'حفظ إعدادات التفعيل',
  'Set as Repeating Quote': 'تعيين كعرض سعر دوري',
  'Repeat Schedule': 'جدول التكرار',
  'Repeat every': 'التكرار كل',
  'Weeks': 'أسابيع',
  'Months': 'أشهر',
  'Next Quote Date': 'تاريخ عرض السعر التالي',
  'Generate As': 'إنشاء بالحالة',
  'Save Repeating Schedule': 'حفظ جدول التكرار',
  'Days after quote date': 'أيام بعد تاريخ عرض السعر',
  'Days after end of month': 'أيام بعد نهاية الشهر',
  'of the next month': 'من الشهر التالي',
  'of the current month': 'من الشهر الحالي',
  'Share Live Link': 'مشاركة الرابط المباشر',
  'Quote Link': 'رابط عرض السعر',
  'Anyone with this link will be able to view this quotation live through the client portal.': 'يمكن لأي شخص لديه هذا الرابط عرض عرض السعر مباشرة عبر بوابة العميل.',
  'Scan this QR code with any mobile device to view this quotation live in the portal.': 'امسح رمز QR هذا بأي جهاز محمول لعرض عرض السعر مباشرة في البوابة.',
  'Select a quote to download as PDF': 'اختر عرض سعر لتنزيله بصيغة PDF',
  'Download the selected quote': 'تنزيل عرض السعر المحدد',
  'More quote options': 'مزيد من خيارات عرض السعر',
  'Account description...': 'وصف الحساب...',
  'Customer name...': 'اسم العميل...',
  'Enter terms and conditions...': 'أدخل الشروط والأحكام...',
  'Terms & Approval': 'الشروط والاعتماد',
  'Terms & Conditions': 'الشروط والأحكام',
  'Dear [Customer Name], ...': 'عزيزي [Customer Name]، ...',
  '[Customer Name]': '[Customer Name]',
  '[Quote Number]': '[Quote Number]',
  '[Quote Expiry Date]': '[Quote Expiry Date]',
  '[Quote Line Items]': '[Quote Line Items]',
  '[Quotation Value]': '[Quotation Value]',
  '[Invoice Status]': '[Invoice Status]',
  'Dear [Customer Name],\n\nThis is a friendly reminder that your quote [Quote Number] is expiring soon on [Quote Expiry Date].\n\nQuote Details:\n[Quote Line Items]\n\nTotal Value: [Quotation Value]\n\nPlease let us know if you have any questions.\n\nBest regards,\nThe Team': 'عزيزي [Customer Name]،\n\nنود تذكيركم بأن عرض السعر [Quote Number] سينتهي قريبًا بتاريخ [Quote Expiry Date].\n\nتفاصيل عرض السعر:\n[Quote Line Items]\n\nإجمالي القيمة: [Quotation Value]\n\nيرجى التواصل معنا إذا كانت لديكم أي استفسارات.\n\nمع خالص التحية،\nفريق العمل',
  'Dear [Customer Name],\n\nYour quote [Quote Number] expires today ([Quote Expiry Date]).\n\nQuote Details:\n[Quote Line Items]\n\nTotal Value: [Quotation Value]\n\nIf you would like to proceed, please accept the quote before the end of the day.\n\nBest regards,\nThe Team': 'عزيزي [Customer Name]،\n\nينتهي عرض السعر [Quote Number] اليوم ([Quote Expiry Date]).\n\nتفاصيل عرض السعر:\n[Quote Line Items]\n\nإجمالي القيمة: [Quotation Value]\n\nإذا رغبتم في المتابعة، يرجى قبول عرض السعر قبل نهاية اليوم.\n\nمع خالص التحية،\nفريق العمل',
  'Dear [Customer Name],\n\nWe noticed your quote [Quote Number] expired on [Quote Expiry Date].\n\nQuote Details:\n[Quote Line Items]\n\nTotal Value: [Quotation Value]\n\n[Invoice Status]\n\nIf you are still interested in these services, please contact us to renew the quote.\n\nBest regards,\nThe Team': 'عزيزي [Customer Name]،\n\nلاحظنا أن عرض السعر [Quote Number] قد انتهى بتاريخ [Quote Expiry Date].\n\nتفاصيل عرض السعر:\n[Quote Line Items]\n\nإجمالي القيمة: [Quotation Value]\n\n[Invoice Status]\n\nإذا كنتم لا تزالون مهتمين بهذه الخدمات، يرجى التواصل معنا لتجديد عرض السعر.\n\nمع خالص التحية،\nفريق العمل',
  'Dear [Customer Name],\n\nFollowing up on quote [Quote Number] which expired two weeks ago. \n\nQuote Details:\n[Quote Line Items]\n\nTotal Value: [Quotation Value]\n\n[Invoice Status]\n\nWe would love to work with you. Please let us know if we can still help with your requirements.\n\nBest regards,\nThe Team': 'عزيزي [Customer Name]،\n\nنتابع معكم بشأن عرض السعر [Quote Number] الذي انتهى منذ أسبوعين. \n\nتفاصيل عرض السعر:\n[Quote Line Items]\n\nإجمالي القيمة: [Quotation Value]\n\n[Invoice Status]\n\nيسعدنا العمل معكم. يرجى إبلاغنا إذا كان بإمكاننا مساعدتكم في تلبية متطلباتكم.\n\nمع خالص التحية،\nفريق العمل',

  // Purchase orders, bills, receipts, and landed costs.
  'New Purchase Order': 'أمر شراء جديد',
  'Edit Purchase Order': 'تعديل أمر الشراء',
  'Delete Purchase Order': 'حذف أمر الشراء',
  'Process Order': 'معالجة أمر الشراء',
  'Manage your orders to vendors and suppliers': 'إدارة أوامر الشراء للموردين',
  'Search orders...': 'ابحث في أوامر الشراء...',
  'Loading orders...': 'جاري تحميل أوامر الشراء...',
  'No purchase orders found': 'لم يتم العثور على أوامر شراء',
  'Create your first order to get started': 'أنشئ أول أمر شراء للبدء',
  'Purchase order converted to bill': 'تم تحويل أمر الشراء إلى فاتورة مشتريات',
  'Purchase order deleted': 'تم حذف أمر الشراء',
  'Migrated to Accepted': 'تم تحويل الحالة إلى مقبول',
  'Failed to convert purchase order to bill': 'تعذر تحويل أمر الشراء إلى فاتورة مشتريات',
  'Failed to create Bill': 'تعذر إنشاء فاتورة المشتريات',
  'Failed to create partial bill': 'تعذر إنشاء فاتورة مشتريات جزئية',
  'Failed to delete purchase order': 'تعذر حذف أمر الشراء',
  'Failed to load purchase orders': 'تعذر تحميل أوامر الشراء',
  'Failed to save purchase order': 'تعذر حفظ أمر الشراء',
  'Failed to upload file': 'تعذر رفع الملف',
  'Error updating inventory': 'حدث خطأ أثناء تحديث المخزون',
  'Attachments are not available in local mode.': 'المرفقات غير متاحة في الوضع المحلي.',
  'Bill conversion is not available in local mode.': 'تحويل أمر الشراء إلى فاتورة غير متاح في الوضع المحلي.',
  'Receiving purchase orders is not available in local mode.': 'استلام أوامر الشراء غير متاح في الوضع المحلي.',
  'Status updates are not available in local mode.': 'تحديث الحالة غير متاح في الوضع المحلي.',
  'Partial billing coming soon. Opening full bill for now.': 'الفوترة الجزئية ستتوفر قريبًا. سيتم فتح فاتورة كاملة حاليًا.',
  'This order is already fully billed.': 'تمت فوترة أمر الشراء بالكامل بالفعل.',
  'Please specify at least one item quantity to bill.': 'يرجى تحديد كمية صنف واحدة على الأقل لفوترتها.',
  'Create Bill': 'إنشاء فاتورة مشتريات',
  'Create Partial Bill': 'إنشاء فاتورة مشتريات جزئية',
  'Full Bill': 'فاتورة مشتريات كاملة',
  'Partial Bill': 'فاتورة مشتريات جزئية',
  'Qty to Bill Now': 'الكمية المراد فوترتها الآن',
  'Previously Billed': 'تمت فوترته سابقًا',
  'Receive Items': 'استلام الأصناف',
  'Receive Goods': 'استلام البضاعة',
  'Receive Now': 'استلام الآن',
  'Confirm Delivery': 'تأكيد التسليم',
  'Delivery Address': 'عنوان التسليم',
  'Delivery Instructions': 'تعليمات التسليم',
  'Enter delivery address...': 'أدخل عنوان التسليم...',
  'Enter delivery instructions...': 'أدخل تعليمات التسليم...',
  'Select Delivery Warehouse': 'اختر مستودع التسليم',
  'No warehouses defined. Items will be received into the default warehouse.': 'لم يتم تعريف مستودعات. ستُستلم الأصناف في المستودع الافتراضي.',
  'Lot Selection & Expiry': 'اختيار التشغيلة وتاريخ الصلاحية',
  'Lot # / Expiry': 'رقم التشغيلة / الصلاحية',
  'New Lot / PO Number': 'رقم تشغيلة / أمر شراء جديد',
  'No Lot': 'بدون تشغيلة',
  'Exp:': 'الصلاحية:',
  'Send to Supplier': 'إرسال إلى المورد',
  'Send via Email': 'إرسال بالبريد الإلكتروني',
  'View Bill': 'عرض فاتورة المشتريات',
  'Printing functionality for multiple purchase orders is being prepared.': 'يجري إعداد طباعة عدة أوامر شراء.',
  'Email functionality for multiple purchase orders is being prepared.': 'يجري إعداد إرسال عدة أوامر شراء بالبريد الإلكتروني.',
  'Are you sure you want to delete this purchase order? This action cannot be undone.': 'هل أنت متأكد من حذف أمر الشراء هذا؟ لا يمكن التراجع عن هذا الإجراء.',
  'Allocate Landed Costs': 'توزيع التكاليف الإضافية',
  'Landed Cost (Shipping/Fees)': 'التكلفة الإضافية (الشحن/الرسوم)',
  'Landed Freight/Duty': 'تكلفة الشحن والرسوم الجمركية',
  'Allocated Landed Costs (True Cost)': 'التكاليف الإضافية الموزعة (التكلفة الفعلية)',
  'Landed Allocation': 'توزيع التكلفة الإضافية',
  'Add Expense': 'إضافة مصروف',
  'Cost Type (e.g. Freight)': 'نوع التكلفة (مثل الشحن)',
  'Enter total extra costs to distribute...': 'أدخل إجمالي التكاليف الإضافية المراد توزيعها...',
  '1. Expense Lines': '1. بنود المصروفات',
  '2. Allocation Method': '2. طريقة التوزيع',
  '3. Allocation Preview': '3. معاينة التوزيع',
  'Allocation Method *': 'طريقة التوزيع *',
  'By Value': 'حسب القيمة',
  'By Quantity': 'حسب الكمية',
  'By Weight/Volume': 'حسب الوزن/الحجم',
  '(Line Price / Total PO Price) * Expense': '(قيمة البند / إجمالي قيمة أمر الشراء) × المصروف',
  '(Line Qty / Total PO Qty) * Expense': '(كمية البند / إجمالي كمية أمر الشراء) × المصروف',
  'Based on product weight fields': 'استنادًا إلى حقول وزن المنتج',
  'Cost will be distributed among items based on their line total value.': 'سيتم توزيع التكلفة على الأصناف وفق إجمالي قيمة كل بند.',
  'Choose how to distribute the total selected expenses across the PO items.': 'اختر كيفية توزيع إجمالي المصروفات المحددة على أصناف أمر الشراء.',
  'Calculate Preview': 'حساب المعاينة',
  'Apply Landed Cost': 'تطبيق التكلفة الإضافية',
  'Base Unit Cost': 'تكلفة الوحدة الأساسية',
  'Base Total': 'الإجمالي الأساسي',
  'Adj. Unit Cost': 'تكلفة الوحدة المعدلة',
  'New Weighted Unit Cost': 'تكلفة الوحدة المرجحة الجديدة',
  'True Cost (Total)': 'التكلفة الفعلية (الإجمالي)',
  'Total Expense Applied:': 'إجمالي المصروف المطبق:',
  'Landed costs successfully allocated!': 'تم توزيع التكاليف الإضافية بنجاح!',
  'Failed to apply landed costs': 'تعذر تطبيق التكاليف الإضافية',
  'New Bill': 'فاتورة مشتريات جديدة',
  'New Repeating Bill': 'فاتورة مشتريات دورية جديدة',
  '+ Repeating Bill': '+ فاتورة مشتريات دورية',
  '+ Credit Note': '+ إشعار دائن',
  'Update Bill': 'تحديث فاتورة المشتريات',
  'Manage and pay your supplier invoices': 'إدارة فواتير الموردين وسدادها',
  'Bills to pay': 'فواتير واجبة السداد',
  'Search bills...': 'ابحث في فواتير المشتريات...',
  'Loading bills...': 'جاري تحميل فواتير المشتريات...',
  'No bills found': 'لم يتم العثور على فواتير مشتريات',
  'Add your first bill to start tracking payables': 'أضف أول فاتورة مشتريات لبدء متابعة الذمم الدائنة',
  'Bill approved': 'تم اعتماد فاتورة المشتريات',
  'Bill deleted': 'تم حذف فاتورة المشتريات',
  'Bill voided': 'تم إلغاء فاتورة المشتريات',
  'Sent for approval': 'تم الإرسال للاعتماد',
  'Recurring bill generated': 'تم إنشاء فاتورة المشتريات الدورية',
  'Recurring bill generation did not return a document': 'لم تُرجع عملية إنشاء الفاتورة الدورية مستندًا',
  'Journal posting is server-side in local mode.': 'يتم ترحيل القيد على الخادم في الوضع المحلي.',
  'Bill imports are server-side in local mode.': 'تتم معالجة استيراد فواتير المشتريات على الخادم في الوضع المحلي.',
  'Delivery and inventory flows are server-side in local mode.': 'تتم معالجة إجراءات التسليم والمخزون على الخادم في الوضع المحلي.',
  'Could not attach file to bill': 'تعذر إرفاق الملف بفاتورة المشتريات',
  'Failed to delete bill': 'تعذر حذف فاتورة المشتريات',
  'Failed to generate recurring bill': 'تعذر إنشاء فاتورة المشتريات الدورية',
  'Failed to import bills': 'تعذر استيراد فواتير المشتريات',
  'Failed to load bills': 'تعذر تحميل فواتير المشتريات',
  'Failed to save bill': 'تعذر حفظ فاتورة المشتريات',
  'File is too large. Max size is 20MB': 'الملف كبير جدًا. الحد الأقصى 20 ميجابايت',
  'Please enter a valid amount': 'يرجى إدخال مبلغ صحيح',
  'Please select an account': 'يرجى اختيار حساب',
  'Please specify at least one quantity to receive.': 'يرجى تحديد كمية واحدة على الأقل للاستلام.',
  'Goods Receipt created successfully': 'تم إنشاء إشعار استلام البضاعة بنجاح',
  'Goods Receipt updated': 'تم تحديث إشعار استلام البضاعة',
  'Error creating Goods Receipt': 'حدث خطأ أثناء إنشاء إشعار استلام البضاعة',
  'Create Goods Receipt': 'إنشاء إشعار استلام بضاعة',
  'Items Received': 'الأصناف المستلمة',
  'Lot/Batch No.': 'رقم التشغيلة/الدفعة',
  'Attach File': 'إرفاق ملف',
  'Choose File': 'اختر ملفًا',
  'Import Bills': 'استيراد فواتير المشتريات',
  'Select a CSV file to import your bills': 'اختر ملف CSV لاستيراد فواتير المشتريات',
  'Your CSV must include the following columns:': 'يجب أن يتضمن ملف CSV الأعمدة التالية:',
  'Required Format': 'التنسيق المطلوب',
  'Download Template': 'تنزيل القالب',
  'Download Template CSV': 'تنزيل قالب CSV',
  'Upload CSV': 'رفع ملف CSV',
  'Generate Bill': 'إنشاء فاتورة مشتريات',
  'Week(s)': 'أسبوع/أسابيع',
  'Month(s)': 'شهر/أشهر',
  'Next Bill Date': 'تاريخ الفاتورة التالية',
  'day(s) after bill date': 'يوم/أيام بعد تاريخ الفاتورة',
  'day of following month': 'يوم من الشهر التالي',
  'day of current month': 'يوم من الشهر الحالي',
  'day(s) after end of bill month': 'يوم/أيام بعد نهاية شهر الفاتورة',
  'Approve As': 'اعتماد بالحالة',
  'Send for Approval': 'إرسال للاعتماد',
  'Paid From *': 'مدفوع من *',
  'Payment Date *': 'تاريخ الدفع *',
  'Payment Method *': 'طريقة الدفع *',
  'Record Payment': 'تسجيل دفعة',
  'Bank Transfer': 'تحويل بنكي',
  'Cash': 'نقدًا',
  'Credit Card': 'بطاقة ائتمان',
  'Check': 'شيك',
  'Payment Terms': 'شروط السداد',
  'This will remove the payment of': 'سيؤدي هذا إلى إزالة الدفعة بمبلغ',
  '. The amount due on this bill will increase.': '. سيزداد المبلغ المستحق على فاتورة المشتريات.',
  'recorded on': 'المسجلة بتاريخ',
  'Are you sure you want to delete this bill? This action cannot be undone.': 'هل أنت متأكد من حذف فاتورة المشتريات هذه؟ لا يمكن التراجع عن هذا الإجراء.',
  'Printing functionality for multiple bills is being prepared.': 'يجري إعداد طباعة عدة فواتير مشتريات.',
  'Email functionality for multiple bills is being prepared.': 'يجري إعداد إرسال عدة فواتير مشتريات بالبريد الإلكتروني.',
  'Submission': 'تسجيل التكلفة',
  'Allocation': 'التوزيع',
  'New Cost Submission': 'تسجيل تكلفة إضافية جديدة',
  'Submit costs and allocate them to Purchase Orders.': 'سجّل التكاليف الإضافية ووزعها على أوامر الشراء.',
  'From Account (Credit) *': 'من الحساب (دائن) *',
  'Intermediary Account (Debit) *': 'الحساب الوسيط (مدين) *',
  'Inventory Account (Debit) *': 'حساب المخزون (مدين) *',
  'Available Cost Submissions *': 'التكاليف المسجلة المتاحة *',
  'Target Purchase Order *': 'أمر الشراء المستهدف *',
  'Select source account...': 'اختر حساب المصدر...',
  'Select intermediary account...': 'اختر الحساب الوسيط...',
  'Select submission to allocate...': 'اختر التكلفة المراد توزيعها...',
  'Select Purchase Order...': 'اختر أمر شراء...',
  'Select Inventory Account...': 'اختر حساب المخزون...',
  'Submit Cost & Create Journal': 'تسجيل التكلفة وإنشاء القيد',
  'Allocate Cost to PO': 'توزيع التكلفة على أمر الشراء',
  'Allocate & Post Journal': 'توزيع التكلفة وترحيل القيد',
  'Please fill all fields': 'يرجى استكمال جميع الحقول',
  'Please select submission, PO, inventory account, and allocation method': 'يرجى اختيار التكلفة المسجلة وأمر الشراء وحساب المخزون وطريقة التوزيع',
  'No items found in selected PO': 'لم يتم العثور على أصناف في أمر الشراء المحدد',
  'Cannot allocate: Total value/quantity is zero': 'لا يمكن التوزيع: إجمالي القيمة/الكمية يساوي صفرًا',
  'Landed Cost Submission created successfully': 'تم تسجيل التكلفة الإضافية بنجاح',
  'Landed Cost Allocated Successfully': 'تم توزيع التكلفة الإضافية بنجاح',
  'Error creating submission': 'حدث خطأ أثناء تسجيل التكلفة',
  'Error allocating landed costs': 'حدث خطأ أثناء توزيع التكاليف الإضافية',
  'Could not load landed cost data': 'تعذر تحميل بيانات التكاليف الإضافية',
  'e.g. Freight Cost 001': 'مثال: تكلفة شحن 001',

  // Sales and purchase delivery workflows.
  'Shipment Tracking & Returns': 'تتبع الشحنات والمرتجعات',
  'Shipment Manifest': 'بيان الشحنة',
  'Shipment Financial Value': 'القيمة المالية للشحنة',
  'Original Delivery Manifest': 'بيان التسليم الأصلي',
  'Proof of Delivery': 'إثبات التسليم',
  'Inventory Check-Out': 'إخراج المخزون',
  'Finalize Check-Out': 'إتمام إخراج المخزون',
  'Ready for Shipment': 'جاهز للشحن',
  'Complete Delivery': 'إتمام التسليم',
  'Confirm & Sign Delivery': 'تأكيد التسليم وتوقيعه',
  'Receiver Name (Required)': 'اسم المستلم (مطلوب)',
  'Digital Signature (Required)': 'التوقيع الرقمي (مطلوب)',
  'Who received the package?': 'من استلم الطرد؟',
  'Enter receiver\'s name...': 'أدخل اسم المستلم...',
  'Take Package Photo': 'التقاط صورة للطرد',
  'Take/Upload Package Photo': 'التقاط/رفع صورة للطرد',
  'Package Photo': 'صورة الطرد',
  'Photo Captured': 'تم التقاط الصورة',
  'Photo Linked': 'الصورة مرتبطة',
  'Electronically Signed': 'موقّع إلكترونيًا',
  'View Package Photo': 'عرض صورة الطرد',
  'View Signature': 'عرض التوقيع',
  'Assigned Personnel': 'الموظف المسؤول',
  'Assigned To': 'مُسند إلى',
  'Select Personnel': 'اختر الموظف',
  'Personnel name...': 'اسم الموظف...',
  'Courier': 'مندوب التوصيل',
  'Delivery #': 'رقم التسليم',
  'From Delivery #': 'من التسليم رقم',
  'Invoice:': 'الفاتورة:',
  'Bill:': 'فاتورة المشتريات:',
  '| Customer:': '| العميل:',
  'Items Validated': 'تم التحقق من الأصناف',
  'Verifying stock levels...': 'جاري التحقق من أرصدة المخزون...',
  'Scanning components for #': 'جاري فحص مكونات التسليم رقم',
  'On Hand:': 'الرصيد المتاح:',
  'Required:': 'المطلوب:',
  'Shortage': 'عجز',
  'Item Return': 'إرجاع أصناف',
  'Initiate Return': 'بدء الإرجاع',
  'Process return': 'معالجة الإرجاع',
  'Confirm Return to Stock': 'تأكيد الإرجاع إلى المخزون',
  'ReturnQty': 'كمية المرتجع',
  'Please select items to return': 'يرجى اختيار الأصناف المراد إرجاعها',
  'Return processed successfully': 'تمت معالجة المرتجع بنجاح',
  'A warehouse or store location is required to complete this delivery': 'يلزم تحديد مستودع أو موقع متجر لإتمام هذا التسليم',
  'A warehouse or store location is required to process this return': 'يلزم تحديد مستودع أو موقع متجر لمعالجة هذا المرتجع',
  'A warehouse or store location is required to process a return': 'يلزم تحديد مستودع أو موقع متجر لمعالجة المرتجع',
  'A warehouse or store location is required to receive inventory': 'يلزم تحديد مستودع أو موقع متجر لاستلام المخزون',
  'Delivery checked out and marked as Shipped!': 'تم إخراج التسليم من المخزون وتعيينه كمشحون!',
  'Successfully delivered and inventory updated!': 'تم التسليم وتحديث المخزون بنجاح!',
  'Inventory receipt recorded and delivery marked as complete': 'تم تسجيل استلام المخزون وتعليم التسليم كمكتمل',
  'Delivery Note printed successfully': 'تمت طباعة إشعار التسليم بنجاح',
  'CSV exported successfully': 'تم تصدير ملف CSV بنجاح',
  'No deliveries to export': 'لا توجد تسليمات للتصدير',
  'No shipments found matching your filters.': 'لا توجد شحنات مطابقة لعوامل التصفية.',
  'Failed to fetch deliveries': 'تعذر جلب التسليمات',
  'Failed to load deliveries': 'تعذر تحميل التسليمات',
  'Failed to finalize check out': 'تعذر إتمام إخراج المخزون',
  'Failed to process return': 'تعذرت معالجة المرتجع',
  'Failed to verify stock levels': 'تعذر التحقق من أرصدة المخزون',
  'Failed to record inventory receipt': 'تعذر تسجيل استلام المخزون',
  'Failed to generate Delivery Note PDF': 'تعذر إنشاء ملف PDF لإشعار التسليم',
  'Import feature coming soon': 'ميزة الاستيراد ستتوفر قريبًا',
  'Excel export feature coming soon': 'ميزة التصدير إلى Excel ستتوفر قريبًا',
  'Delivery reminders coming soon': 'تذكيرات التسليم ستتوفر قريبًا',
  'Repeating deliveries coming soon': 'التسليمات الدورية ستتوفر قريبًا',
  'Print Note': 'طباعة الإشعار',
  'Print PDF': 'طباعة PDF',
  'Print Now': 'اطبع الآن',
  'Print Preview': 'معاينة الطباعة',
  'Exit': 'خروج',

  // Expense submissions.
  'Review and approve employee expense claims': 'مراجعة واعتماد مطالبات مصروفات الموظفين',
  'Search submissions...': 'ابحث في طلبات المصروفات...',
  'Upload Expense Bills': 'رفع فواتير المصروفات',
  'Upload expense bill images': 'رفع صور فواتير المصروفات',
  'Receipt / Invoice Scan': 'صورة الإيصال / الفاتورة',
  'Add descriptions and select the account. AI will automatically extract and process the expense details.': 'أضف الأوصاف واختر الحساب، وسيستخرج الذكاء الاصطناعي تفاصيل المصروفات ويعالجها تلقائيًا.',
  'Specify Details for Each Expense Bill': 'تحديد تفاصيل كل فاتورة مصروف',
  'Specify Expense Bill Details': 'تحديد تفاصيل فاتورة المصروف',
  'Selected Files (': 'الملفات المحددة (',
  'Select All (': 'تحديد الكل (',
  'selected)': 'محدد)',
  'Clear All': 'مسح الكل',
  'Add More Files': 'إضافة ملفات أخرى',
  'Upload Guidelines:': 'إرشادات الرفع:',
  'PNG, JPG, GIF, WEBP up to 6MB each': 'PNG وJPG وGIF وWEBP بحد أقصى 6 ميجابايت لكل ملف',
  'Maximum file size: 6MB per image': 'الحد الأقصى لحجم كل صورة: 6 ميجابايت',
  'Only image files (PNG, JPG, GIF, WEBP) are accepted': 'تُقبل ملفات الصور فقط (PNG وJPG وGIF وWEBP)',
  'You can upload multiple images at once': 'يمكنك رفع عدة صور دفعة واحدة',
  'Clear, readable images work best for expense tracking': 'الصور الواضحة والمقروءة تحقق أفضل نتائج في تتبع المصروفات',
  'or drag and drop': 'أو اسحب الملفات وأفلتها',
  'File:': 'الملف:',
  'Paid From': 'مدفوع من',
  'Optional notes': 'ملاحظات اختيارية',
  'Processing...': 'جاري المعالجة...',
  'Recording...': 'جاري التسجيل...',
  'Submission ID': 'رقم الطلب',
  'Submitted By': 'مقدم الطلب',
  'Extracted Contact Name': 'اسم جهة الاتصال المستخرج',
  'Stored Contact': 'جهة الاتصال المسجلة',
  'Select Contact': 'اختر جهة اتصال',
  'Category': 'الفئة',
  'Category...': 'الفئة...',
  'Add Line Item': 'إضافة بند مصروف',
  'Verified': 'تم التحقق',
  'Payments': 'المدفوعات',
  'No payments recorded yet.': 'لم يتم تسجيل مدفوعات بعد.',
  'Remaining:': 'المتبقي:',
  'Open in new tab': 'فتح في علامة تبويب جديدة',
  'Failed to load local expense data': 'تعذر تحميل بيانات المصروفات المحلية',
  'Failed to process some bills. Please try again.': 'تعذرت معالجة بعض الفواتير. يرجى المحاولة مرة أخرى.',
  'You can only upload up to 100 images at once.': 'يمكن رفع ما يصل إلى 100 صورة فقط في المرة الواحدة.',
  'Receipt upload did not return a file URL': 'لم تُرجع عملية رفع الإيصال رابطًا للملف',
  'Optional reference number': 'رقم مرجع اختياري',
  'Select method...': 'اختر طريقة الدفع...',
  'User name...': 'اسم المستخدم...',
  'Reject': 'رفض',

  // Contacts and contact import.
  'All Contacts': 'جميع جهات الاتصال',
  'Archived Contacts': 'جهات الاتصال المؤرشفة',
  'Manage your': 'إدارة',
  'relationships and details': 'العلاقات والتفاصيل',
  'Search contacts...': 'ابحث في جهات الاتصال...',
  'Loading contacts...': 'جاري تحميل جهات الاتصال...',
  'No contacts found': 'لم يتم العثور على جهات اتصال',
  'Add your first contact to start managing relationships': 'أضف أول جهة اتصال لبدء إدارة العلاقات',
  'New Contact': 'جهة اتصال جديدة',
  'Add New Contact': 'إضافة جهة اتصال جديدة',
  'Create Contact': 'إنشاء جهة اتصال',
  'Edit Contact': 'تعديل جهة الاتصال',
  'Update Contact': 'تحديث جهة الاتصال',
  'Save Contact': 'حفظ جهة الاتصال',
  'Back to Contacts': 'العودة إلى جهات الاتصال',
  'Back to Contact': 'العودة إلى جهة الاتصال',
  'Contact Type *': 'نوع جهة الاتصال *',
  'Type & Status': 'النوع والحالة',
  'Basic Information': 'المعلومات الأساسية',
  'Full Name / Company Name *': 'الاسم الكامل / اسم الشركة *',
  'Name of the primary contact': 'اسم جهة الاتصال الرئيسية',
  'Email Address': 'عنوان البريد الإلكتروني',
  'Email Addresses': 'عناوين البريد الإلكتروني',
  'Add Email': 'إضافة بريد إلكتروني',
  'Phone Number': 'رقم الهاتف',
  'Phone Numbers': 'أرقام الهاتف',
  'Add Phone': 'إضافة رقم هاتف',
  'Website': 'الموقع الإلكتروني',
  'Addresses': 'العناوين',
  'Street, City, Country, Zip Code': 'الشارع، المدينة، الدولة، الرمز البريدي',
  'City / Region': 'المدينة / المنطقة',
  'Billing Address': 'عنوان الفوترة',
  'Tax Information': 'المعلومات الضريبية',
  'Tax ID / Number': 'الرقم الضريبي',
  'VAT / Tax ID': 'رقم ضريبة القيمة المضافة / الرقم الضريبي',
  'Trade License Number': 'رقم الرخصة التجارية',
  'Financial Details': 'التفاصيل المالية',
  'Bank Account': 'الحساب البنكي',
  'Sales Defaults': 'الإعدادات الافتراضية للمبيعات',
  'Purchase Defaults': 'الإعدادات الافتراضية للمشتريات',
  'Contact Persons': 'أشخاص الاتصال',
  'Assigned People': 'الأشخاص المسؤولون',
  'Person Name': 'اسم الشخص',
  'Add Person': 'إضافة شخص',
  'Key Person': 'جهة اتصال رئيسية',
  'Key': 'رئيسي',
  'Primary': 'رئيسي',
  'No contact persons added': 'لم تتم إضافة أشخاص اتصال',
  'No contact persons assigned.': 'لم يتم تعيين أشخاص اتصال.',
  'Internal notes about this contact...': 'ملاحظات داخلية عن جهة الاتصال...',
  'Contact archived': 'تمت أرشفة جهة الاتصال',
  'Contact restored': 'تمت استعادة جهة الاتصال',
  'Archive Contact': 'أرشفة جهة الاتصال',
  'Restore Contact': 'استعادة جهة الاتصال',
  'Are you sure you want to archive this contact? It will be moved to the Archived section.': 'هل أنت متأكد من أرشفة جهة الاتصال هذه؟ سيتم نقلها إلى قسم المؤرشفة.',
  'Could not load contact setup data': 'تعذر تحميل بيانات إعداد جهات الاتصال',
  'Failed to archive contact': 'تعذرت أرشفة جهة الاتصال',
  'Failed to load contacts': 'تعذر تحميل جهات الاتصال',
  'Failed to restore contact': 'تعذرت استعادة جهة الاتصال',
  'Failed to save contact': 'تعذر حفظ جهة الاتصال',
  'Profile image updated': 'تم تحديث صورة الملف',
  'Updating profile image...': 'جاري تحديث صورة الملف...',
  'Failed to update profile image': 'تعذر تحديث صورة الملف',
  'Please upload an image file': 'يرجى رفع ملف صورة',
  'Attachments': 'المرفقات',
  'Files': 'الملفات',
  'File management': 'إدارة الملفات',
  'No attachments yet': 'لا توجد مرفقات بعد',
  'Upload First File': 'رفع أول ملف',
  'Upload images or PDFs related to this contact': 'ارفع صورًا أو ملفات PDF مرتبطة بجهة الاتصال',
  'Edit Document': 'تعديل المستند',
  'Statement Type': 'نوع كشف الحساب',
  'Activity': 'الحركة',
  'Outstanding': 'الأرصدة المستحقة',
  'Statement for': 'كشف حساب لـ',
  'Send Statement': 'إرسال كشف الحساب',
  'Statement downloaded as Excel': 'تم تنزيل كشف الحساب بصيغة Excel',
  'Statement downloaded as PDF': 'تم تنزيل كشف الحساب بصيغة PDF',
  'Statement sent successfully': 'تم إرسال كشف الحساب بنجاح',
  'Balance': 'الرصيد',
  'Balance Due': 'الرصيد المستحق',
  'Total Receivable': 'إجمالي الذمم المدينة',
  'Total Overdue': 'إجمالي المتأخرات',
  'Total Payable': 'إجمالي الذمم الدائنة',
  'Invoices awaiting payment': 'فواتير بانتظار السداد',
  'Past due date': 'متجاوزة تاريخ الاستحقاق',
  'Collected payments': 'المدفوعات المحصلة',
  'Amount you owe': 'المبلغ المستحق عليك',
  'Invoice History': 'سجل الفواتير',
  'Bills History': 'سجل فواتير المشتريات',
  'Fetching invoices...': 'جاري جلب الفواتير...',
  'Fetching bills...': 'جاري جلب فواتير المشتريات...',
  'found for this contact.': 'لهذه الجهة.',
  'Import Contacts': 'استيراد جهات الاتصال',
  '+ Add New Tag': '+ إضافة وسم جديد',
  'Enter tag name...': 'أدخل اسم الوسم...',
  'Tag created successfully': 'تم إنشاء الوسم بنجاح',
  'Failed to create tag': 'تعذر إنشاء الوسم',
  'Filter by location...': 'تصفية حسب الموقع...',
  'Search tax ID...': 'ابحث بالرقم الضريبي...',
  'Search license...': 'ابحث برقم الرخصة...',
  'Search email...': 'ابحث بالبريد الإلكتروني...',
  'Search phone...': 'ابحث برقم الهاتف...',
  'Filter by account #...': 'تصفية حسب رقم الحساب...',
  'What would you like to import?': 'ما نوع جهات الاتصال التي تريد استيرادها؟',
  'Select the type of contacts you want to bring into the system.': 'اختر نوع جهات الاتصال التي تريد إدخالها إلى النظام.',
  'Import Customers': 'استيراد العملاء',
  'Import Suppliers': 'استيراد الموردين',
  'Import your client database and sales contacts': 'استيراد قاعدة بيانات العملاء وجهات اتصال المبيعات',
  'Import your vendors and service providers': 'استيراد الموردين ومقدمي الخدمات',
  'Type': 'النوع',
  'Upload a CSV file containing your': 'ارفع ملف CSV يحتوي على سجلات',
  'records.': '.',
  'Template': 'قالب',
  'File to upload': 'الملف المراد رفعه',
  'Drag and drop CSV file or select manually': 'اسحب ملف CSV وأفلته أو حدده يدويًا',
  'Select file': 'اختيار ملف',
  'Review': 'مراجعة',
  'We found': 'عثرنا على',
  's in your file.': ' في ملفك.',
  'Complete Import': 'إكمال الاستيراد',
  'Failed to import contacts': 'تعذر استيراد جهات الاتصال',

  // Export/import columns, placeholders, and document/PDF labels.
  'Customer Name': 'اسم العميل',
  'Supplier...': 'المورد...',
  'Vendor...': 'المورد...',
  'Customer...': 'العميل...',
  'Vendor/Contact': 'المورد/جهة الاتصال',
  'Contact *': 'جهة الاتصال *',
  'Select a contact': 'اختر جهة اتصال',
  'Select Customer': 'اختر عميلًا',
  'Select a vendor': 'اختر موردًا',
  'Enter a customer': 'أدخل عميلًا',
  'Walk-in Customer': 'عميل نقدي',
  'Walk-in Contact': 'جهة اتصال نقدية',
  'Phone': 'الهاتف',
  'Address': 'العنوان',
  'Tax Number': 'الرقم الضريبي',
  'Notes': 'الملاحظات',
  'Subject': 'الموضوع',
  'Message': 'الرسالة',
  'File': 'الملف',
  'KB': 'كيلوبايت',
  'MB': 'ميجابايت',
  'Excel (.xlsx)': 'Excel (.xlsx)',
  'PDF (.pdf)': 'PDF (.pdf)',
  'CSV file': 'ملف CSV',
  'Upload CSV file': 'رفع ملف CSV',
  'Download CSV template': 'تنزيل قالب CSV',
  'Export CSV': 'تصدير CSV',
  'Export Excel': 'تصدير Excel',
  'Export data to CSV': 'تصدير البيانات إلى CSV',
  'Export data to Excel': 'تصدير البيانات إلى Excel',
  'Download PDF': 'تنزيل PDF',
  'No address provided': 'لم يتم إدخال عنوان',
  'Unique reference number': 'رقم مرجع فريد',
  'Detailed table of products/services': 'جدول تفصيلي للمنتجات/الخدمات',
  'Total amount with currency': 'إجمالي المبلغ مع العملة',
  'Expiry/Due date format': 'تنسيق تاريخ الانتهاء/الاستحقاق',
  'Payment Instructions': 'تعليمات الدفع',
  'DATE': 'التاريخ',
  'REFERENCE / NOTE': 'المرجع / الملاحظة',
  'e.g. Acme Corp': 'مثال: شركة أكمي',
  'e.g. Project Alpha': 'مثال: مشروع ألفا',
  'e.g. Project X': 'مثال: مشروع س',
  'e.g. Sales Revenue': 'مثال: إيرادات المبيعات',
  'e.g. Monthly Service': 'مثال: خدمة شهرية',
  'e.g. JPY': 'مثال: JPY',
  'e.g. PO-123': 'مثال: PO-123',
  'e.g. TXN-123': 'مثال: TXN-123',
  'e.g. TXN-12345': 'مثال: TXN-12345',
  'e.g. INV-9988': 'مثال: INV-9988',
  'INV-001...': 'INV-001...',
  'PO-001...': 'PO-001...',
  'PO-...': 'PO-...',
  'REF-001...': 'REF-001...',
  'DLV-...': 'DLV-...',
  'DN-': 'DN-',
  'QAR': 'QAR',
  'Need help?': 'هل تحتاج إلى مساعدة؟',
  'Local session token is unavailable': 'رمز الجلسة المحلية غير متاح',
  'Request failed': 'فشل الطلب',
  'Unknown error': 'خطأ غير معروف',
};

export const salesPurchasesPatterns: Array<[
  RegExp,
  (...matches: string[]) => string,
]> = [
  [/^(\d+) invoices voided$/i, count => `تم إلغاء ${count} فاتورة`],
  [/^(\d+) invoices approved$/i, count => `تم اعتماد ${count} فاتورة`],
  [/^(\d+) invoices submitted for approval$/i, count => `تم إرسال ${count} فاتورة للاعتماد`],
  [/^(\d+) invoices skipped because they have payments$/i, count => `تم تخطي ${count} فاتورة لوجود مدفوعات عليها`],
  [/^Successfully imported (\d+) invoices$/i, count => `تم استيراد ${count} فاتورة بنجاح`],
  [/^(\d+) quotes? deleted$/i, count => `تم حذف ${count} عرض سعر`],
  [/^(\d+) quotes approved$/i, count => `تم اعتماد ${count} عرض سعر`],
  [/^(\d+) quotes submitted for approval$/i, count => `تم إرسال ${count} عرض سعر للاعتماد`],
  [/^Successfully imported (\d+) quotes$/i, count => `تم استيراد ${count} عرض سعر بنجاح`],
  [/^(\d+) quotes selected$/i, count => `تم تحديد ${count} عرض سعر`],
  [/^Opened (\d+) quote email drafts?$/i, count => `تم فتح ${count} مسودة بريد إلكتروني لعرض السعر`],
  [/^(\d+) quotes? skipped because the contact email is missing$/i, count => `تم تخطي ${count} عرض سعر لعدم توفر بريد جهة الاتصال`],
  [/^(\d+) email drafts? (?:was|were) blocked\. Allow pop-ups and try again\.$/i, count => `تم حظر ${count} مسودة بريد إلكتروني. اسمح بالنوافذ المنبثقة ثم حاول مرة أخرى.`],
  [/^(\d+) purchase orders deleted$/i, count => `تم حذف ${count} أمر شراء`],
  [/^(\d+) purchase orders approved$/i, count => `تم اعتماد ${count} أمر شراء`],
  [/^(\d+) purchase orders submitted for approval$/i, count => `تم إرسال ${count} أمر شراء للاعتماد`],
  [/^(\d+) bills voided$/i, count => `تم إلغاء ${count} فاتورة مشتريات`],
  [/^(\d+) bills approved$/i, count => `تم اعتماد ${count} فاتورة مشتريات`],
  [/^(\d+) bills submitted for approval$/i, count => `تم إرسال ${count} فاتورة مشتريات للاعتماد`],
  [/^Successfully imported (\d+) bills$/i, count => `تم استيراد ${count} فاتورة مشتريات بنجاح`],
  [/^Successfully imported (\d+) (Customer|Supplier)s$/i, (count, type) => `تم استيراد ${count} ${type.toLowerCase() === 'customer' ? 'عميل' : 'مورد'} بنجاح`],
  [/^AI is extracting information from (\d+) bills?\.\.\.$/i, count => `يجري الذكاء الاصطناعي استخراج المعلومات من ${count} فاتورة...`],
  [/^Successfully processed (\d+) expense bills?!$/i, count => `تمت معالجة ${count} فاتورة مصروف بنجاح!`],
  [/^Cannot check out: Shortage for (\d+) item\(s\)$/i, count => `لا يمكن إخراج المخزون: يوجد عجز في ${count} صنف`],
  [/^File "(.+)" attached successfully$/i, fileName => `تم إرفاق الملف "${fileName}" بنجاح`],
  [/^Attached file: (.+)$/i, fileName => `تم إرفاق الملف: ${fileName}`],
  [/^Uploading (.+)\.\.\.$/i, value => `جاري رفع ${value}...`],
  [/^Uploading (\d+)%$/i, progress => `جاري الرفع ${progress}%`],
  [/^Failed to upload file: (.+)$/i, error => `تعذر رفع الملف: ${error}`],
  [/^Failed to upload: (.+)$/i, error => `تعذر الرفع: ${error}`],
  [/^Failed to upload file \((.+)\)$/i, error => `تعذر رفع الملف (${error})`],
  [/^Failed to generate PDF: (.+)$/i, error => `تعذر إنشاء ملف PDF: ${error}`],
  [/^(.+) is not a supported image format\.$/i, fileName => `${fileName} ليس بتنسيق صور مدعوم.`],
  [/^(.+) exceeds the 6MB size limit\.$/i, fileName => `${fileName} يتجاوز الحد الأقصى للحجم وهو 6 ميجابايت.`],
  [/^Invoice (.+) approved$/i, documentNumber => `تم اعتماد الفاتورة ${documentNumber}`],
  [/^Could not update invoice (.+)$/i, documentNumber => `تعذر تحديث الفاتورة ${documentNumber}`],
  [/^Bill (.+) created successfully$/i, documentNumber => `تم إنشاء فاتورة المشتريات ${documentNumber} بنجاح`],
  [/^Partial Bill (.+) created successfully$/i, documentNumber => `تم إنشاء فاتورة المشتريات الجزئية ${documentNumber} بنجاح`],
  [/^Draft invoice (.+) created successfully$/i, documentNumber => `تم إنشاء الفاتورة المسودة ${documentNumber} بنجاح`],
  [/^Partial Invoice (.+) created successfully$/i, documentNumber => `تم إنشاء الفاتورة الجزئية ${documentNumber} بنجاح`],
  [/^Delivery status updated to (Draft|Assigned|Shipped|Delivered|CheckingOut|Returned)$/i, status => {
    const translatedStatus: Record<string, string> = {
      draft: 'مسودة',
      assigned: 'مُسند',
      shipped: 'تم الشحن',
      delivered: 'تم التسليم',
      checkingout: 'قيد إخراج المخزون',
      returned: 'مرتجع',
    };
    return `تم تحديث حالة التسليم إلى ${translatedStatus[status.toLowerCase()] || status}`;
  }],
  [/^Successfully copied as draft (.+)$/i, documentType => `تم النسخ بنجاح كمسودة ${documentType}`],
  [/^Failed to copy to (.+)$/i, documentType => `تعذر النسخ إلى ${documentType}`],
  [/^Failed to copy quote as (.+)$/i, documentType => `تعذر نسخ عرض السعر كـ ${documentType}`],
  [/^Invalid quantity for (.+)\. Cannot exceed remaining quantity\.$/i, itemName => `الكمية غير صحيحة للصنف ${itemName}. لا يمكن تجاوز الكمية المتبقية.`],
  [/^Please add a reason for declining quote (.+)\.$/i, documentNumber => `يرجى إضافة سبب لرفض عرض السعر ${documentNumber}.`],
  [/^Select quantities to invoice for Quote (.+)$/i, documentNumber => `اختر الكميات المطلوب فوترتها لعرض السعر ${documentNumber}`],
  [/^Ref:\s*(.+)$/i, reference => `المرجع: ${reference}`],
  [/^Delivery #:\s*(.+)$/i, documentNumber => `رقم التسليم: ${documentNumber}`],
  [/^Bill:\s*(.+)$/i, documentNumber => `فاتورة المشتريات: ${documentNumber}`],
  [/^Invoice:\s*(.+)$/i, documentNumber => `الفاتورة: ${documentNumber}`],
  [/^Shipped:\s*(.+)$/i, date => `تم الشحن: ${date}`],
  [/^Shipped (.+)$/i, date => `تم الشحن ${date}`],
  [/^Delivered At:\s*(.+)$/i, date => `تم التسليم في: ${date}`],
  [/^Received By:\s*(.+)$/i, receiverName => `استلمها: ${receiverName}`],
  [/^Scanning components for #(.+)$/i, documentNumber => `جاري فحص مكونات التسليم رقم ${documentNumber}`],
  [/^Search (invoices|quotations|credit notes)\.\.\.$/i, type => {
    const labels: Record<string, string> = {
      invoices: 'الفواتير',
      quotations: 'عروض الأسعار',
      'credit notes': 'الإشعارات الدائنة',
    };
    return `ابحث في ${labels[type.toLowerCase()] || type}...`;
  }],
  [/^Search (bills|purchase orders)\.\.\.$/i, type => `ابحث في ${type.toLowerCase() === 'bills' ? 'فواتير المشتريات' : 'أوامر الشراء'}...`],
  [/^New (Customer|Supplier|Both|All)$/i, type => {
    const labels: Record<string, string> = {
      customer: 'عميل جديد',
      supplier: 'مورد جديد',
      both: 'جهة اتصال جديدة',
      all: 'جهة اتصال جديدة',
    };
    return labels[type.toLowerCase()] || `جديد ${type}`;
  }],
  [/^(Customer|Supplier|Both|All)s$/i, type => {
    const labels: Record<string, string> = {
      customer: 'العملاء',
      supplier: 'الموردون',
      both: 'جهات الاتصال',
      all: 'جميع جهات الاتصال',
    };
    return labels[type.toLowerCase()] || type;
  }],
  [/^Upload (Customer|Supplier)s$/i, type => `رفع ملف ${type.toLowerCase() === 'customer' ? 'العملاء' : 'الموردين'}`],
  [/^Download (Customer|Supplier) Template$/i, type => `تنزيل قالب ${type.toLowerCase() === 'customer' ? 'العملاء' : 'الموردين'}`],
  [/^Review (Customer|Supplier)s$/i, type => `مراجعة ${type.toLowerCase() === 'customer' ? 'العملاء' : 'الموردين'}`],
  [/^We found (\d+) (customer|supplier)s in your file\.$/i, (count, type) => `عثرنا على ${count} ${type.toLowerCase() === 'customer' ? 'عميل' : 'مورد'} في ملفك.`],
  [/^Sending statement to (.+)\.\.\.$/i, recipient => `جاري إرسال كشف الحساب إلى ${recipient}...`],
  [/^Statement for (.+)$/i, contactName => `كشف حساب لـ ${contactName}`],
  [/^(\d+) (invoice|bill|quote|purchase order)s? found for this contact\.$/i, (count, type) => {
    const labels: Record<string, string> = {
      invoice: 'فاتورة مبيعات',
      bill: 'فاتورة مشتريات',
      quote: 'عرض سعر',
      'purchase order': 'أمر شراء',
    };
    return `تم العثور على ${count} ${labels[type.toLowerCase()] || type} لجهة الاتصال هذه.`;
  }],
  [/^Failed to load tags: (\d+)$/i, status => `تعذر تحميل الوسوم: ${status}`],
  [/^Failed to load contact documents: (\d+)$/i, status => `تعذر تحميل مستندات جهة الاتصال: ${status}`],
  [/^Request failed \((\d+)\)$/i, status => `فشل الطلب (${status})`],
  [/^Failed to create inventory receipt \((\d+)\)$/i, status => `تعذر إنشاء استلام المخزون (${status})`],
  [/^\$([\d,.]+) \((.+)\)$/i, (amount, date) => `$${amount} (${date})`],
];
